/**
 * Výkup calculator — tab switching, purity input, quick-weight/purity presets.
 */
(function () {
  'use strict';

  function formatPrice(value) {
    return value.toLocaleString('cs-CZ') + ' Kč';
  }

  function initSteppers(section) {
    section.querySelectorAll('[data-stepper]').forEach(function (stepper) {
      var step = parseFloat(stepper.getAttribute('data-stepper')) || 1;
      var input = stepper.parentElement.querySelector('input[type="number"]');
      if (!input) return;

      stepper.querySelector('[data-stepper-up]').addEventListener('click', function () {
        var val = parseFloat(input.value) || 0;
        var max = parseFloat(input.getAttribute('max'));
        val += step;
        if (!isNaN(max) && val > max) val = max;
        input.value = val;
        input.dispatchEvent(new Event('input', { bubbles: true }));
      });

      stepper.querySelector('[data-stepper-down]').addEventListener('click', function () {
        var val = parseFloat(input.value) || 0;
        var min = parseFloat(input.getAttribute('min'));
        val -= step;
        if (!isNaN(min) && val < min) val = min;
        if (isNaN(min) && val < 0) val = 0;
        input.value = val;
        input.dispatchEvent(new Event('input', { bubbles: true }));
      });
    });
  }

  function initCalculator(section) {
    var tabs = section.querySelectorAll('[data-vykup-tab]');
    var panels = section.querySelectorAll('[data-vykup-panel]');

    initSteppers(section);

    // Tab switching
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var target = this.getAttribute('data-vykup-tab');

        tabs.forEach(function (t) { t.classList.remove('is-active'); });
        panels.forEach(function (p) { p.classList.remove('is-active'); });

        this.classList.add('is-active');
        section.setAttribute('data-active-metal', target);
        var panel = section.querySelector('[data-vykup-panel="' + target + '"]');
        if (panel) panel.classList.add('is-active');
      });
    });

    // Weight input change
    var weightInputs = section.querySelectorAll('[data-vykup-weight]');
    weightInputs.forEach(function (input) {
      input.addEventListener('input', function () {
        var panel = this.closest('.vykup-calculator__panel');
        if (panel) {
          panel.querySelectorAll('[data-vykup-quick-weights] .vykup-calculator__quick-weight').forEach(function (btn) {
            btn.classList.remove('is-active');
          });
        }
        updateResult(section);
      });
    });

    // Purity input change
    var purityInputs = section.querySelectorAll('[data-vykup-purity]');
    purityInputs.forEach(function (input) {
      input.addEventListener('input', function () {
        var panel = this.closest('.vykup-calculator__panel');
        if (panel) {
          panel.querySelectorAll('[data-vykup-quick-purities] .vykup-calculator__quick-weight').forEach(function (btn) {
            btn.classList.remove('is-active');
          });
        }
        updateResult(section);
      });
    });

    // Quick-weight presets
    var quickWeightGroups = section.querySelectorAll('[data-vykup-quick-weights]');
    quickWeightGroups.forEach(function (group) {
      var buttons = group.querySelectorAll('.vykup-calculator__quick-weight');
      buttons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var weight = this.getAttribute('data-weight');
          var panel = this.closest('.vykup-calculator__panel');
          if (!panel) return;

          var input = panel.querySelector('[data-vykup-weight]');
          if (input) {
            input.value = weight;
            input.dispatchEvent(new Event('input', { bubbles: true }));
          }

          buttons.forEach(function (b) { b.classList.remove('is-active'); });
          this.classList.add('is-active');

          updateResult(section);
        });
      });
    });

    // Quick-purity presets
    var quickPurityGroups = section.querySelectorAll('[data-vykup-quick-purities]');
    quickPurityGroups.forEach(function (group) {
      var buttons = group.querySelectorAll('.vykup-calculator__quick-weight');
      buttons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var permille = this.getAttribute('data-purity-permille');
          var panel = this.closest('.vykup-calculator__panel');
          if (!panel) return;

          var input = panel.querySelector('[data-vykup-purity]');
          if (input) {
            input.value = permille === 'unknown' ? '' : permille;
          }

          buttons.forEach(function (b) { b.classList.remove('is-active'); });
          this.classList.add('is-active');

          updateResult(section);
        });
      });
    });

    // Investment checkbox (gold panel only)
    var investmentCheckbox = section.querySelector('[data-vykup-investment]');
    if (investmentCheckbox) {
      investmentCheckbox.addEventListener('change', function () {
        var panel = this.closest('.vykup-calculator__panel');
        if (!panel) return;

        var purityInput = panel.querySelector('[data-vykup-purity]');
        var purityField = purityInput ? purityInput.closest('.vykup-calculator__field') : null;
        var weightInput = panel.querySelector('[data-vykup-weight]');

        if (this.checked) {
          if (purityInput) {
            purityInput.value = 999;
            purityInput.disabled = true;
          }
          if (purityField) purityField.classList.add('is-disabled');
          if (weightInput) weightInput.setAttribute('max', '100');
          // Deactivate purity quick buttons
          panel.querySelectorAll('[data-vykup-quick-purities] .vykup-calculator__quick-weight').forEach(function (btn) {
            btn.classList.remove('is-active');
            btn.disabled = true;
          });
        } else {
          if (purityInput) {
            purityInput.value = '';
            purityInput.disabled = false;
          }
          if (purityField) purityField.classList.remove('is-disabled');
          if (weightInput) weightInput.removeAttribute('max');
          panel.querySelectorAll('[data-vykup-quick-purities] .vykup-calculator__quick-weight').forEach(function (btn) {
            btn.disabled = false;
          });
        }

        updateResult(section);
      });
    }
  }

  function updateResult(section) {
    var activePanel = section.querySelector('.vykup-calculator__panel.is-active');
    if (!activePanel) return;

    var weightInput = activePanel.querySelector('[data-vykup-weight]');
    var purityInput = activePanel.querySelector('[data-vykup-purity]');
    var resultValue = activePanel.querySelector('.vykup-calculator__result-value');
    var resultSummary = activePanel.querySelector('[data-vykup-summary]');

    if (!weightInput || !resultValue) return;

    var weight = parseFloat(weightInput.value);
    var purityPermille = purityInput ? parseFloat(purityInput.value) : NaN;
    if (!isNaN(purityPermille)) {
      if (purityPermille < 1) purityPermille = NaN;
      if (purityPermille > 999) purityPermille = 999;
    }
    var hasPurity = !isNaN(purityPermille) && purityPermille > 0;

    var activeTab = section.querySelector('.vykup-calculator__tab.is-active');
    var tabKey = activeTab ? activeTab.getAttribute('data-vykup-tab') : 'gold';
    var metalName = tabKey === 'silver' ? 'stříbra' : 'zlata';

    // Get base prices from data attributes
    var goldPrice = parseFloat(section.getAttribute('data-gold-price')) || 0;
    var silverPrice = parseFloat(section.getAttribute('data-silver-price')) || 0;
    // Gold buyback price is 3.1% below the configured rate
    var basePrice = tabKey === 'silver' ? silverPrice : goldPrice * 0.969;

    // Investment premium (0.5% for certified gold bullion/coins)
    var investmentCheckbox = section.querySelector('[data-vykup-investment]');
    if (investmentCheckbox && investmentCheckbox.checked && tabKey === 'gold') {
      basePrice = basePrice * 1.005;
    }

    if (isNaN(weight) || weight <= 0) {
      resultValue.textContent = '— Kč';
      if (resultSummary) resultSummary.textContent = '';
      return;
    }

    if (basePrice <= 0) {
      resultValue.textContent = '— Kč';
      if (resultSummary) resultSummary.textContent = '';
      return;
    }

    if (!hasPurity) {
      // Show range: lowest to highest purity from presets
      var presetButtons = activePanel.querySelectorAll('[data-vykup-quick-purities] .vykup-calculator__quick-weight[data-purity]');
      var purities = [];
      presetButtons.forEach(function (p) {
        var v = parseFloat(p.getAttribute('data-purity'));
        if (!isNaN(v)) purities.push(v);
      });
      if (purities.length === 0) {
        resultValue.textContent = '— Kč';
        return;
      }
      var minPurity = Math.min.apply(null, purities);
      var maxPurity = Math.max.apply(null, purities);
      if (maxPurity >= 0.999) maxPurity = 1.0;
      var minPrice = Math.round(weight * minPurity * basePrice);
      var maxPrice = Math.round(weight * maxPurity * basePrice);
      resultValue.textContent = formatPrice(minPrice) + ' – ' + formatPrice(maxPrice);
      if (resultSummary) {
        resultSummary.textContent = 'Rozsah cen za ' + weight + ' g ' + metalName + ' (všechny ryzosti)';
      }
    } else {
      var purity = purityPermille / 1000;
      if (purity >= 0.999) purity = 1.0;
      var total = Math.round(weight * purity * basePrice);
      resultValue.textContent = formatPrice(total);
      if (resultSummary) {
        resultSummary.textContent = 'Cena za ' + weight + ' g ' + metalName + ' ryzosti ' + Math.round(purityPermille) + '/1000';
      }
    }
  }

  // Initialize all calculator sections on the page
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-vykup-calculator]').forEach(initCalculator);
    initModal();
  });

  // Modal open/close
  function initModal() {
    var modal = document.querySelector('[data-vykup-modal]');
    if (!modal) return;

    document.querySelectorAll('[data-vykup-modal-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        modal.hidden = false;
        document.body.style.overflow = 'hidden';
        if (window.AvarrioOpeningHours) window.AvarrioOpeningHours.update();
      });
    });

    modal.querySelectorAll('[data-vykup-modal-close]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        modal.hidden = true;
        document.body.style.overflow = '';
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) {
        modal.hidden = true;
        document.body.style.overflow = '';
      }
    });
  }

  // Shopify section rendering support
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) {
      var calc = event.target.querySelector('[data-vykup-calculator]');
      if (calc) initCalculator(calc);
    });
  }
})();
